import { createApp, ref } from 'vue'
import { AstraPlugin, defineOrugaBulmaConfig } from '@platform/astra-vue'
import { OrugaConfig, Collapse, OCollapse } from '@oruga-ui/oruga-next'

export const createCollapsePR = () => {
  // console.log('collapse-pr')
  return createApp({
    mounted() {
      //console.log('...', this.active)
    },
    setup() {
      //console.log('history-collapse:setup')
      const active = ref(0)

      return {
        active
      }
    }
  })
    .use(OrugaConfig, { ...defineOrugaBulmaConfig })
    .use(Collapse)
    .use(AstraPlugin, {})
    .mount('.collapse-pr')
}
